import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=45cf0f9e&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"
import style0 from "./Models.vue?vue&type=style&index=0&id=45cf0f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf0f9e",
  null
  
)

export default component.exports